import { Location } from 'vue-router'
import { Report } from '@/typings/api/Report'

import { createView } from '@/helpers/enums/table-actions'
import { dateFormatter } from '@/helpers/dateFormatter'
import {
  LK_REPORT_ROUTES as ROUTES,
  geReportFilename,
} from './utils'


const getViewRoute = (data: Report): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.id?.toString() },
})

const getViewFilter = (data: Report): boolean => (
  data.has_raw_data
)

export const TABLE_ACTIONS = Object.freeze([
  createView(getViewRoute, getViewFilter),
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'title',
    sortable: false,
  },
  {
    text: 'Дата обновления',
    value: 'created_at',
    sortable: false,
    width: 130,
    field: (value: Report['created_at']) => (
      value && dateFormatter(value, undefined, '-')
    ),
  },
  {
    text: 'Статус',
    value: 'status',
    sortable: false,
    width: 200,
    field: (status: Report['status'], data: Report) => ({
      status,
      url: data.raw_file?.url,
      filename: geReportFilename(data),
      tooltip: data.error_msg,
    }),
  },
])
